import React, { Fragment } from "react";
import { Line, Circle } from "react-konva";
import CustomMode from "./Custom.Mode";
import { connect } from "react-redux";
import { MODE_TYPE } from "../../store/reducers/mode.reducer";

class PencilMode extends CustomMode {
  state = {
    data: {}
  };

  constructor(props) {
    super(props);
    this.data = Object.assign(this.getDefaultData(props), props.data);
  }

  getDefaultData(props) {
    return {
      points: [],
      color: props.pencilModeColor,
      isActive: true
    };
  }

  componentDidUpdate() {
    const {
      currentModeType,
      isMouseDown,
      mousePosX,
      mousePosY,
      onDataUpdate
    } = this.props;
    if (currentModeType !== MODE_TYPE.PENCIL_MODE) return;
    if (!isMouseDown) return;
    this.calculatePoints(mousePosX, mousePosY);
    onDataUpdate(this.data);
  }

  calculatePoints(mousePosX, mousePosY) {
    let points = [...this.data.points];
    if (points.length == 0) {
      points.push(mousePosX, mousePosY);
      return (this.data.points = points);
    }

    let lastPosX = points[points.length - 2];
    let lastPosY = points[points.length - 1];

    if (mousePosX === lastPosX && mousePosY === lastPosY) return;
    points.push(mousePosX, mousePosY);
    return (this.data.points = points);
  }

  shouldComponentUpdate() {
    return this.data.isActive;
  }

  render() {
    return (
      <Line
        points={[...this.data.points]}
        tension={0.2}
        stroke={this.data.color}
        strokeWidth={5}
      />
    );
  }
}

export default connect(PencilMode.mapStateToProps)(PencilMode);
